import React, { useEffect, useRef } from 'react'

export type CollapsibleCardRef = React.RefObject<{
  onOpen: () => void
  onClose: () => void
  onToggle: () => void
}>

export const useCollapsibleCardSync = (
  shouldHideFilters: boolean
): CollapsibleCardRef => {
  const collapsibleCardRef = useRef({
    onOpen: () => ({}),
    onClose: () => ({}),
    onToggle: () => ({})
  })

  useEffect(() => {
    if (!shouldHideFilters) {
      collapsibleCardRef.current?.onOpen()
      return
    }

    collapsibleCardRef.current?.onClose()
  }, [shouldHideFilters])

  return collapsibleCardRef
}
